module.exports = __webpack_public_path__ + "img/default_pattern_bg_m.fdbc7715.png";